import { HttpClient } from 'api/http-client';
class AutomationValidationHttpClient extends HttpClient {
    getFieldRelatedAutomationCount(fieldId) {
        return this.get(`/automation-validation/field/${fieldId}`);
    }
    getPlaceholderRelatedAutomationCount(teamId) {
        return this.get(`/automation-validation/placeholder/${teamId}`);
    }
    getTemplateRelatedAutomationCount(templateId) {
        return this.get(`/automation-validation/template/${templateId}`);
    }
    getTaskRelatedAutomationCount(taskId) {
        return this.get(`/automation-validation/task/${taskId}`);
    }
    getPhaseRelatedAutomationCount(phaseId) {
        return this.get(`/automation-validation/phase/${phaseId}`);
    }
    getSheetRelatedAutomationCount(sheetId) {
        return this.get(`/automation-validation/sheet/${sheetId}`);
    }
    getSheetTemplateRelatedAutomationCount(sheetTemplateId) {
        return this.get(`/automation-validation/sheet-template/${sheetTemplateId}`);
    }
}
export const AutomationValidationApi = new AutomationValidationHttpClient();
